<template>
  <div class="list-detail" :id="uuid">
    <button type="button" class="list-detail-back" @click="showGrid">
      <IconBack />
      Back to Neighborhoods
    </button>
    <div class="list-detail-inner" :id="`list-detail_${community.slug}`">
      <div class="list-detail-header">
        <h3 class="list-detail-header-title">{{ community.title }}</h3>
      </div>
      <div class="list-detail-image slick-loading">
        <div class="list-detail-slider" :id="`list-slider-${community.id}`">
          <div
            class="list-detail-image-slide"
            v-for="(slide, i) in community.slide_images"
            :key="`list-detail-slider-slide-${i}`"
          >
            <img :src="slide.url" :alt="slide.title" />
          </div>
        </div>
        <div class="list-detail-slider-controls">
          <button type="button" class="arrow-prev" :id="`arrow-prev-${community.id}`">
            <IconTriangleLeft />
          </button>
          <button type="button" class="arrow-next" :id="`arrow-next-${community.id}`">
            <IconTriangleRight />
          </button>
        </div>
      </div>
      <div class="list-detail-meta">
        <div class="list-detail-meta-cost">
          Starting at
          <div class="list-detail-meta-cost-num">{{ startingAt }}</div>
        </div>
        <template v-if="isNotComingSoon">
          <div class="list-detail-meta-block">
            <div class="list-detail-meta-block-icon">
              <IconBeds />
            </div>
            {{ beds }} beds
          </div>
          <div class="list-detail-meta-block">
            <div class="list-detail-meta-block-icon">
              <IconBaths />
            </div>
            {{ baths }} baths
          </div>
          <div class="list-detail-meta-block">
            <div class="list-detail-meta-block-icon">
              <IconSqFeet />
            </div>
            {{ community.sq_ft + '+' || '-' }} sqft
          </div>
        </template>
      </div>
      <div class="list-detail-categories">
        <div class="list-detail-category">Property Type</div>
        <div class="list-detail-category-text">{{ community.property_type }}</div>
        <div class="list-detail-category">Location</div>
        <div class="list-detail-category-text">{{ community.location }}</div>
        <div class="list-detail-category">School District</div>
        <div class="list-detail-category-text">{{ community.school_district }}</div>
      </div>
      <a :href="community.link" class="btn btn-full btn-dark">View Homes</a>
      <div class="list-detail-more">
        <div v-if="community.style && community.style !== 'Custom'" class="list-detail-half">
          <div class="list-detail-more-label">Style</div>
          <ul>
            <li>{{ community.style || '-' }}</li>
          </ul>
        </div>
        <div v-if="community.special_features.length" class="list-detail-full">
          <div class="list-detail-more-label">Special Features</div>
          <ul>
            <li v-for="(feature, i) in community.special_features" :key="`special-features-${i}`">
              {{ feature.feature }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IconBack from '@/components/icons/IconBack';
import IconBaths from '@/components/icons/IconBaths';
import IconBeds from '@/components/icons/IconBeds';
import IconSqFeet from '@/components/icons/IconSqFeet';
import IconTriangleLeft from '@/components/icons/IconTriangleLeft';
import IconTriangleRight from '@/components/icons/IconTriangleRight';
import hasSlickSlider from '@/mixins/hasSlickSlider';
import { uuidv4 } from '@/helpers/ui';

export default {
  name: 'CommunityListDetail',
  components: { IconBack, IconBaths, IconBeds, IconSqFeet, IconTriangleLeft, IconTriangleRight },
  mixins: [hasSlickSlider],
  data() {
    return {
      sliderClass: '.list-detail-slider',
    };
  },
  computed: {
    baths() {
      if (!this.community.baths) {
        return '?';
      }

      if (this.community.baths_min) {
        if (this.community.baths_min > this.community.baths) {
          return `${this.community.baths_min}+`;
        }

        return `${this.community.baths_min} - ${this.community.baths}`;
      }

      return this.community.baths;
    },
    beds() {
      if (!this.community.beds) {
        return '?';
      }

      if (this.community.beds_min) {
        if (this.community.beds_min > this.community.beds) {
          return `${this.community.beds_min}+`;
        }

        return `${this.community.beds_min} - ${this.community.beds}`;
      }

      return this.community.beds;
    },
    community() {
      return this.$store.getters['ui/getDetailedCommunity'];
    },
    isNotComingSoon() {
      return this.community.coming_soon != true;
    },
    startingAt() {
      return Number(this.community.price.replaceAll(',', '')) > 0 ? '$' + this.community.price + '+' : 'Contact Us';
    },
    uuid() {
      return uuidv4();
    },
  },
  watch: {
    community: function(newValue, oldValue) {
      // console.log('CommunityListDetail watch community', newValue, oldValue);
      if (oldValue !== false) {
        this.sliderUpdatePending = true;
      }
    },
  },
  methods: {
    showGrid() {
      this.$store.dispatch('ui/setPanelView', { community: false, panelView: 'grid' });
    },
  },
};
</script>
